import script from "./PublicSectorBalanceSheetForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicSectorBalanceSheetForm.vue?vue&type=script&setup=true&lang=js"

import "./PublicSectorBalanceSheetForm.vue?vue&type=style&index=0&id=1668365e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1668365e"]])

export default __exports__